export var SAFER_GAMBLING_EVENT_NAME = 'safer_gambling_interactions';
export var PAGEVIEW_EVENT_NAME = 'pageview';
export var ACCOUNT_MENU_EVENT_NAME = 'account_menu';
export var PROFIT_LOSS_EVENT_NAME = 'my_transactions_interactions';